function getFormData(object: Object) {
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, object[key as keyof object]));
    return formData;
}

export default getFormData;